function adjustMegamenu() {
    var viewportWidth = $(window).width();
    var viewportHeight = $(window).height();
    var perItemHeight = 40;
    var headerExtarHeight = 200;
    var covorArea = viewportHeight - headerExtarHeight;
    var maxFitItemCount = covorArea / perItemHeight;
    $(".custom_adjust_link_menu").each(function( index ) {
      //console.log("data-title : "+ $(this).attr("data-title"));
      let totalItem = $(this).attr("data-link_count");
      let column_count = 1;
      if(totalItem > maxFitItemCount){
        let column_count = Math.ceil(totalItem / maxFitItemCount);
        $(this).css("column-count", column_count);
        
        if(column_count == 1){
          $(this).parent().siblings(".nav-block--imgs").css("width", "80%");
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(1)").show();
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(1)").css("width", "33.333%");
          
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(2)").show();
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(2)").css("width", "33.333%");
          
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(3)").show();
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(3)").css("width", "33.333%"); 
        }
        
        if(column_count == 2){
          $(this).parent().siblings(".nav-block--imgs").css("width", "50%");
          
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(1)").show();
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(1)").css("width", "50%");
          
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(2)").show();
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(2)").css("width", "50%");
          
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(3)").hide();
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(3)").css("width", "0%");
          
        }
        if( column_count == 3 ){
          $(this).parent().siblings(".nav-block--imgs").css("width", "25%");

          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(1)").show();
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(1)").css("width", "100%");
          
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(2)").hide();
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(2)").css("width", "0%");
          
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(3)").hide();
          $(this).parent().siblings(".nav-block--imgs").children(":nth-child(3)").css("width", "0%");
        }
        if( column_count > 3 ){
          $(this).parent().siblings(".nav-block--imgs").css("width", "0%");
          $(this).parent().siblings(".nav-block--imgs").children().hide();
        }
        
      }else{
        $(this).css("column-count","1");
        $(this).parent().siblings(".nav-block--imgs").css("width", "80%");
        $(this).parent().siblings(".nav-block--imgs").children(":nth-child(1)").show();
        $(this).parent().siblings(".nav-block--imgs").children(":nth-child(1)").css("width", "33.333%");
        
        $(this).parent().siblings(".nav-block--imgs").children(":nth-child(2)").show();
        $(this).parent().siblings(".nav-block--imgs").children(":nth-child(2)").css("width", "33.333%");
        
        $(this).parent().siblings(".nav-block--imgs").children(":nth-child(3)").show();
        $(this).parent().siblings(".nav-block--imgs").children(":nth-child(3)").css("width", "33.333%"); 
      }
    });
}

adjustMegamenu();
$(document).ready(function(){
  
  $(window).on('resize', function() {
      adjustMegamenu();
  });
  
 
  $(".promoImgLiChild").mouseenter(function(){
    var optOption = $(this).find("span.submenu_item_json_code").text().trim();

    if(optOption.length > 0 ){
      var optOptionJson = JSON.parse(optOption); 
      //console.log(optOption);
    
      var promoBlocks = $(this).parent().parent().siblings(".nav-block--imgs").children();
      $(this).parent().parent().siblings(".nav-block--imgs").show();
      promoBlocks.each(function( index ) {
          if(index < optOptionJson.length){
              $(this).parent().removeClass("hidden");
              $( this ).find("img").attr("src", optOptionJson[index].promo_image);
              $( this ).find("img").attr("srcset", optOptionJson[index].promo_image);
              $( this ).find("span.promo--subheading--label").html(`<p>`+optOptionJson[index].title+`</p>`);
              $( this ).find("a.mega__menu--promo-link").attr("href", optOptionJson[index].link);
              $( this ).removeClass("hidden");
              $( this ).find("img").on("error",function(){
                $(this).parent().addClass("hidden");
              });
          }else{
              $( this ).addClass("hidden");
          }
      });
    }else{
      //$(this).parent().parent().siblings(".nav-block--imgs").hide();
      //console.log($(this).parents('.header-nav--menu').prev('summary').html());
      var optOption = $(this).parents('.header-nav--menu').prev('summary').find("span.submenu_item_json_code").html();
      var optOptionJson = JSON.parse(optOption); 
      var promoBlocks = $(this).parents('.header-nav--menu').prev('summary').parent().find(".nav-block--imgs").children();
      promoBlocks.each(function( index ) {
          if(index < optOptionJson.length){
              $(this).parent().removeClass("hidden");
              $( this ).find("img").attr("src", optOptionJson[index].promo_image);
              $( this ).find("img").attr("srcset", optOptionJson[index].promo_image);
              $( this ).find("span.promo--subheading--label").html(`<p>`+optOptionJson[index].title+`</p>`);
              $( this ).find("a.mega__menu--promo-link").attr("href", optOptionJson[index].link);
              $( this ).removeClass("hidden");
              $( this ).find("img").on("error",function(){
                $(this).parent().addClass("hidden");
              });
          }
          // else{
          //     $( this ).addClass("hidden");
          // }
      });

    }

  });
 
  $(".promoImgLiParent").mouseenter(function(){

    var optOption = $(this).find("span.submenu_item_json_code").html();
    var optOptionJson = JSON.parse(optOption); 
    var promoBlocks = $(this).parent().find(".nav-block--imgs").children();

    promoBlocks.each(function( index ) {
        if(index < optOptionJson.length){
            $(this).parent().removeClass("hidden");
            $( this ).find("img").attr("src", optOptionJson[index].promo_image);
            $( this ).find("img").attr("srcset", optOptionJson[index].promo_image);
            $( this ).find("span.promo--subheading--label").html(`<p>`+optOptionJson[index].title+`</p>`);
            $( this ).find("a.mega__menu--promo-link").attr("href", optOptionJson[index].link);
            $( this ).removeClass("hidden");
            $( this ).find("img").on("error",function(){
              $(this).parent().addClass("hidden");
            });

        }else{
            $( this ).addClass("hidden");
        }
    });
 });

  /*Customer support event*/
  var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});
  initGorgiasChatPromise.then(function () { 
      var timer = setInterval(function () { 
          var chatButtonHead = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button')?.contentWindow.document.querySelector('head'); 
          if (!chatButtonHead?.children.length) { 
              return; 
          } 
          clearInterval(timer); 
          var chatButtonIframe = document.querySelector('#chat-button'); 
          chatButtonIframe.style = "display:none;" 
          var myButton = document.querySelector('#customer-support-us');
          myButton.onclick = function () { 
              if (GorgiasChat.isOpen()) { 
                  myButton.classList.remove("open");
                  GorgiasChat.close(); 
              } else { 
                  myButton.classList.add("open");
                  GorgiasChat.open(); 
              } 
          }
        document.addEventListener('mousedown', function(event) {
            var container = document.querySelector('#gorgias-chat-container');
            var isClickInsideChat = myButton.contains(event.target) || (container && container.contains(event.target));
            if (!isClickInsideChat && GorgiasChat.isOpen()) {
                myButton.classList.remove("open");
                GorgiasChat.close(); 
            }
        });


      }, 50); 
  });
  
  
});